import { formatDate } from '../../utils';

export default {
    name: 'v-card',
    props: {
        heading: String,
        subHeading: String,
        startDate: String,
        endDate: String,
        url: String,
        featured: Boolean,
        imageUrl: String,
        overlay: Boolean,
        location: String,
        tag: String,
        isAlertCard: Boolean,
        alertMessage: String,
    },
    data() {
        return {};
    },
    computed: {
        classes() {
            const largeCard = this.featured ? 'articles__large' : '';
            const theme = this.imageUrl || this.overlay || largeCard ? 'card--white' : 'card--shadow';
            const image = this.imageUrl ? 'card--image' : '';
            let overlay = this.overlay ? 'card--overlay-orange' : '';
            overlay = largeCard ? 'card--overlay-blue' : overlay;
            const alertCard = this.featured == false && this.isAlertCard == true ? 'card--alert-card' : '';

            return `${theme} ${image} ${overlay} ${largeCard} ${alertCard}`;
        },
        date() {
            return formatDate(this.startDate, this.endDate);
        },
    },
    template: `
        <a :href="url" class="card" :class="classes">
            <img v-if="imageUrl" class="card__bgimage" :src="imageUrl">

            <div class="card__body">
                <div v-if="featured == false && isAlertCard == true && alertMessage"  class="card__alert-message">
                    <div class="tags">
                        <span class="tags__tag">{{ alertMessage }}</span>
                    </div>
                </div>
                <div class="card__text">
                    <time class="h6" v-if="isAlertCard == false">{{ date }}</time>
                    <p>{{ heading }}</p>
                    <p v-if="subHeading" class="small">{{ subHeading }}</p>

                    <span class="arrowlink">
                        View
                        <svg class="icon">
                            <use xlink:href="#arrow-right"></use>
                        </svg>
                    </span>
                </div>

                <img v-if="imageUrl && featured" class="card__image" :src="imageUrl">
            </div>

            <div class="card__meta" v-if="isAlertCard == false">
                <div v-if="location" class="card__state">
                    <span class="h6 card__state-title">{{ location }}</span>
                    <svg class="icon">
                        <use xlink:href="#pin"></use>
                    </svg>
                </div>
                <div v-if="tag" class="tags">
                    <span class="tags__tag">{{ tag }}</span>
                </div>
            </div>
        </a>
    `,
};
